/**
 * Canonical list of Indian banks — scheduled commercial banks + top small
 * finance & payments banks. Displayed alphabetically in dropdowns across
 * Register, KYC, and Bank Details forms.
 *
 * Use `OTHER_BANK` when a user's bank isn't in the list — free text fallback.
 */
export const OTHER_BANK = "Other (specify manually)";

export const INDIAN_BANKS = [
  // Public Sector Banks (SBI + 11 nationalised)
  "State Bank of India",
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Canara Bank",
  "Central Bank of India",
  "Indian Bank",
  "Indian Overseas Bank",
  "Punjab National Bank",
  "Punjab & Sind Bank",
  "UCO Bank",
  "Union Bank of India",

  // Private Sector Banks (RBI list)
  "Axis Bank",
  "Bandhan Bank",
  "CSB Bank",
  "City Union Bank",
  "DCB Bank",
  "Dhanlaxmi Bank",
  "Federal Bank",
  "HDFC Bank",
  "ICICI Bank",
  "IndusInd Bank",
  "IDBI Bank",
  "IDFC First Bank",
  "Jammu & Kashmir Bank",
  "Karnataka Bank",
  "Karur Vysya Bank",
  "Kotak Mahindra Bank",
  "Nainital Bank",
  "RBL Bank",
  "South Indian Bank",
  "Tamilnad Mercantile Bank",
  "Yes Bank",

  // Small Finance Banks
  "AU Small Finance Bank",
  "Capital Small Finance Bank",
  "Equitas Small Finance Bank",
  "ESAF Small Finance Bank",
  "Fincare Small Finance Bank",
  "Jana Small Finance Bank",
  "North East Small Finance Bank",
  "Shivalik Small Finance Bank",
  "Suryoday Small Finance Bank",
  "Ujjivan Small Finance Bank",
  "Unity Small Finance Bank",
  "Utkarsh Small Finance Bank",

  // Payments Banks
  "Airtel Payments Bank",
  "Fino Payments Bank",
  "India Post Payments Bank",
  "Jio Payments Bank",
  "NSDL Payments Bank",
  "Paytm Payments Bank",

  // Foreign banks operating in India (top few)
  "Citibank",
  "DBS Bank India",
  "Deutsche Bank",
  "HSBC India",
  "Standard Chartered Bank",

  // Regional Rural Banks — top few (users can pick "Other" for the rest)
  "Andhra Pradesh Grameena Vikas Bank",
  "Baroda U.P. Bank",
  "Karnataka Gramin Bank",
  "Kerala Gramin Bank",
  "Madhya Pradesh Gramin Bank",
  "Prathama U.P. Gramin Bank",
  "Rajasthan Marudhara Gramin Bank",
  "Saptagiri Grameena Bank",
  "Tamil Nadu Grama Bank",
  "Uttar Bihar Gramin Bank",

  // Cooperative (top few urban co-op banks)
  "Cosmos Cooperative Bank",
  "Punjab & Maharashtra Co-operative Bank",
  "Saraswat Cooperative Bank",
  "SVC Co-operative Bank",
];

/**
 * The first four letters of an IFSC identify the bank. Once we resolve an
 * IFSC via the Razorpay public API we normalise their `BANK` field against
 * this list — if it matches, we auto-select in the dropdown; otherwise the
 * user is switched to "Other" with the API's `BANK` value pre-filled.
 */
export const normaliseBankName = (raw) => {
  if (!raw) return "";
  const t = raw.trim();
  const hit = INDIAN_BANKS.find(
    (b) => b.toLowerCase() === t.toLowerCase(),
  );
  return hit || t;
};
